import { render, staticRenderFns } from "./QuestionValueEdit.vue?vue&type=template&id=1bc4a70c&"
import script from "./QuestionValueEdit.vue?vue&type=script&lang=ts&"
export * from "./QuestionValueEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc4a70c')) {
      api.createRecord('1bc4a70c', component.options)
    } else {
      api.reload('1bc4a70c', component.options)
    }
    module.hot.accept("./QuestionValueEdit.vue?vue&type=template&id=1bc4a70c&", function () {
      api.rerender('1bc4a70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questions/questionValue/QuestionValueEdit.vue"
export default component.exports